import script from "./ReportError.vue?vue&type=script&lang=js"
export * from "./ReportError.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__